import { Box, Popover, Typography } from "@mui/material";
import React, { useState } from "react";
import { LoaderContext, getContext } from "../../Helpers/Context/Context";
import ButtonTabs from "../../Components/ButtonTabs/ButtonTabs";
import PersonalDetails from "./MemberDetails/PersonalDetailsView";
import PaymentVerificationView from "./MemberDetails/PaymentVerificationView";
import NomineeDetails from "./MemberDetails/NomineeDetailsView";
import EmployeeDetails from "./MemberDetails/EmployeeDetailsView";
import ButtonComponent from "../../Components/ButtonForm/Button";
import { Modal } from "react-bootstrap";
import notify from "../../Helpers/ToastNotification";
import { APICall } from "../../Helpers/Network/APICalls";
import { insertIntoMemberEnrollmentHistory } from "../../Helpers/APIEndPoints/EndPoints";
import { useLocation, useNavigate } from "react-router-dom";
import ButtonForm from "../../Components/ButtonForm/ButtonForm";
import { ApplicationStatus } from "../../Helpers/Enums/ApplicationStatus";
import { RiFileListLine } from "react-icons/ri";
import { makeStyles } from "@mui/styles";
import WitnessDetails from "./MemberDetails/WitnessDetailsView";
import KYCDetails from "./KYCDetails/KYCDetails";
import VerifyModal from "../Common/VerifyModal/VerifyModal";
import { Modules } from "../../Helpers/Enums/Modules";
import { loggedRoleStatus } from "../../Helpers/Enums/Enum";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography component="div">{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

// inside the component
const RegistrationApproval = () => {
  const { state } = useLocation();
  let navigate = useNavigate();

  //localStorage.setItem("MemberId", state?.id);
  const [value, setValue] = React.useState(0);
  const [memberid] = React.useState(state?.id || "");
  const context = getContext();

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(
    null
  );
  const open = Boolean(anchorEl);

  //const memberid = localStorage.getItem("MemberId") || "";

  const tabs = [
    { label: "Personal Details", value: { ...a11yProps(0) } },
    { label: "Witness Details", value: { ...a11yProps(1) } },
    { label: "Employee Details", value: { ...a11yProps(2) } },
    { label: "Nominee Details", value: { ...a11yProps(3) } },
    { label: "KYC Details", value: { ...a11yProps(4) } },
    { label: "Payment Details", value: { ...a11yProps(5) } },
  ];

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <div>
        <Box sx={{ width: "100%" }}>
          <ButtonTabs value={value} handleChange={handleChange} tabs={tabs} />

          <CustomTabPanel value={value} index={0}>
            <PersonalDetails />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={1}>
            <WitnessDetails />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={2}>
            <EmployeeDetails />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={3}>
            <NomineeDetails />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={4}>
            <KYCDetails />
          </CustomTabPanel>
          {context.loggedInAs.label == loggedRoleStatus.label ||
          context.loggedInAs.value == loggedRoleStatus.value ? (
            <CustomTabPanel value={value} index={5}>
              <PaymentVerificationView />
            </CustomTabPanel>
          ) : (
            ""
          )}
        </Box>
      </div>
      <div className="d-flex justify-content-end mt-4">
        <div>
          <ButtonForm
            className="mx-2"
            id="cancel"
            value={<p><i className="far fa-times-circle"></i> Cancel</p> }
            onClick={() => navigate("/RegistrationRequest")}
          />
          {state?.action !== "View" ? (
            <ButtonComponent
              icon={"fas fa-check-double"}
              value={"Verify"}
              style={{ marginLeft: "10px" }}
              id={"saveBtn"}
              //onClick={() => setShowVerifyModal(true)}
              onClick={handleClick}
            >
              <RiFileListLine />
            </ButtonComponent>
          ) : (
            ""
          )}
        </div>
      </div>
      <>
        {/* <Modal
          show={showVerifyModal}
          onHide={() => closeVerifyModal(false)}
          backdrop="static"
          keyboard={false}
          size="lg"
          centered
        >
          <Modal.Body>
            <div className="col-lg-12 col-md-12">
              <div className="row">
                <div className="col-lg-6 col-sm-6 col-xs-6">
                  <div className="">
                    <input
autoComplete={AutoCompleteValue}
                      placeholder={""}
                      value={""}
                      onChange={(val: any) => {
                        let value = val.target.checked;
                        onChange("approve", value);
                      }}
                      type="radio"
                      name="varificarion"
                    />{" "}
                    <span style={{ marginLeft: "12px" }}>Approve</span>
                  </div>
                </div>
                <div className="col-lg-6 col-sm-6 col-xs-6">
                  <div className="">
                    <input
autoComplete={AutoCompleteValue}
                      placeholder={""}
                      value={""}
                      onChange={(val: any) => {
                        let value = val.target.checked;
                        onChange("reject", value);
                      }}
                      type="radio"
                      name="varificarion"
                    />{" "}
                    <span style={{ marginLeft: "12px" }}>Reject</span>
                  </div>
                </div>
              </div>
              <br />
              {!hideShowComment && (
                <div className="row">
                  <div className="col-lg-12 col-sm-12 col-xs-12 ">
                    <div className="form-group">
                      <label>Comments</label>
                      <InputForm
                        placeholder={""}
                        value={comment}
                        textArea={true}
                        onChange={(val: any) => {
                          let value = val.target.value;
                          onChange("comment", value);
                        }}
                      />
                    </div>
                    {error[comment] && (
                      <p style={{ color: "red" }}>{error[comment]}</p>
                    )}
                  </div>
                </div>
              )}
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button
              className="btn btn-cancel"
              style={{ marginLeft: 5 }}
              onClick={() => closeVerifyModal(false)}
            >
              Cancel
            </button>
            <ButtonComponent
              icon={""}
              value={"Submit"}
              style={{ marginLeft: "10px" }}
              id={"saveBtn"}
              onClick={() => onSubmit()}
            />
          </Modal.Footer>
        </Modal> */}
        <VerifyModal
          open={open}
          anchorEl={anchorEl}
          handleClose={handleClose}
          memberid={memberid}
          module={Modules.RegistrationApproval}
        />
      </>
    </>
  );
};

export default RegistrationApproval;
